module.exports = __webpack_public_path__ + "img/2fa.94c39c40.svg";